import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { NzPlacementType } from 'ng-zorro-antd/dropdown';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-frame-replied-admin-config',
  templateUrl: './frame-replied-admin-config.component.html',
  styleUrls: ['./frame-replied-admin-config.component.scss']
})
export class AtwFrameRepliedAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() type: any; // xem đang ở page hay admin
  @Output() changeOptionConfig = new EventEmitter<any>();
  isViewAll: boolean = false;
  isCollapsed: boolean = false;
  positionSelect: NzPlacementType = 'bottomCenter';
  dataConfig: any;
  dataAfterChange: any = {};
  public currentViewAll: any = {};
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
    {
      title: 'dieu_chinh_phan_tu',
      index: 3,
    },
  ];
  public optionsBackground = [
    {
      label: 'hinh_nen',
      value: 'image',
    },
    {
      label: 'mau_nen',
      value: 'color',
    },
  ];
  openBorderConfig: boolean = false;

  effect_hover = [];
  customize = [];
  configMode: 'basic' | 'advanced' = 'basic';


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
        public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    this.initData();

    forkJoin([
      this.http.get('assets/data/effects/frame-products.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
    });
  }

  parserPercent = (value: string): string => value.replace('%', '');
  formatterPercent = (value: number): string => {
    return `${value} %`;
  };

  /** Hàm này thực hiện khởi tạo dữ liệu;
   *
   */
  initData() {
    if (this.objectChoosing && this.device) {
      this.dataConfig = this.objectChoosing[`${this.device}_config`];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.objectChoosing) {
        this.initData();
      }
      if (changes.device) this.device = changes.device.currentValue;
    }
  }

  // updateConfig() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_config']: this.config,
  //       // data: this.data
  //     })
  //     .then((bool: any) => {});
  // }

  // updateClass() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_class']: this.class,
  //     })
  //     .then((bool: any) => {});
  // }

  // updateStaticData() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       staticdata: this.objectChoosing.staticdata,
  //     })
  //     .then((bool: any) => {});
  // }

  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu14: false,
  };
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  openBgColor() {
    document.getElementById('input-color').click();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[2]);
  }

}
